import { store } from '@/redux/store';
import { searchModelElementsListSelector } from '@/redux/modelElements/modelElements.selector';
import type { SearchModelElementDataState } from 'minerva-plugin-api';
import { toPluginModelElement } from '@/services/pluginsManager/adapters/toPluginModelElement';

export const getAllBioEntities = (): SearchModelElementDataState[] => {
  const { getState } = store;
  const bioEntities = searchModelElementsListSelector(getState());

  return (bioEntities || []).map(bioEntity => ({
    ...bioEntity,
    modelElement: toPluginModelElement(bioEntity.modelElement),
  }));
};
